import { bbxKind } from '../agents/bbx-kind.js';
import { OcrExtractionType } from '../agents/extraction-modules/ocrExtractionTypes.js';
import { type TaskTypeBehaviour } from './task-main.js';

export const artBehaviour = {
  implemented: false,
  structureAgentPrompt: '',
  examCreationPrompt: '',
  boundingBox: {
    [bbxKind.STUDENT_ANSWER]: '',
    [bbxKind.MS]: '',
    [bbxKind.GS]: '',
    [bbxKind.TASKS]: '',
  },
  OCR: {
    [OcrExtractionType.STUDENT_ANSWER]: '',
    [OcrExtractionType.TASK_DESCRIPTION]: '',
    [OcrExtractionType.MASTER_SOLUTION]: '',
    [OcrExtractionType.GRADING_CRITERIA]: '',
  },
  generateMS: '',
  generateGS: '',
  grading: '',
} satisfies TaskTypeBehaviour;
